































import { defineComponent } from '@vue/composition-api';
import { SdsDividerLine } from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    name: 'QrCodeDetails',
    props: {
        amount: {
            type: String,
            required: true,
        },
        qrEndDate: {
            type: Date,
            required: false,
            default: undefined,
        },
        showTimer: {
            type: Boolean,
            required: false,
            default: true,
        },
        closeModal: {
            type: Function,
            required: true,
        },
    },
    components: {
        SdsDividerLine,
    },
});
